import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
// import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";
import counterReducer from "../features/counter/counterSlice";
import authReducer from "../features/auth/authSlice";
import propertyReducer from "../features/property/propertySlice";
import stepperReducer from "../features/Stepper/stepperSlice";
import originalDeedReducer from "../features/modal/OriginalDeedModalSlice";
import ResidentialModalReducer from "../features/modal/modalSlices/ResidentialModalSlice";
import CommercialModalReducer from "../features/modal/modalSlices/CommercialModalSlice";
import userReducer from "../features/user/userSlice";
import propertyInputReducer from "../features/property/inputFieldSlices/propertyInputSlice";
import propertyEvaluationInputReducer from "../features/property/inputFieldSlices/propertyEvaluationInputSlice";
import AadhaarDetailsReducer from "../features/property/AadhaarDetailsSlice";
import translateReducer from "../features/Translate/TranslateSlice";
import PartyDetailReducer from "../features/PartyDetail/PartyDetailSlice";
import ModifySliceRducer from "../features/Modify/ModifySlice";
import onlineAppointmentReducer from "../features/OnlineAppointment/OnlineAppointmentSlice";
import ProcedureReducer from "../features/modal/modalSlices/ProcedureSlice";
import eSignDetailsReducer from "../features/eSign/eSignSlice";
import MobileEmailModalReducer from "../features/modal/modalSlices/MobileEmailModalSlice";
import tabReducer from "../features/Payment/tabSlice";
import reviewApprovalReducer from "../features/ReviewApproval/ReviewApprovalSlice";
import uploadDocumentReducer from "../features/uploadDocument/UploadDocumentSlice";

const persistConfig = {
  key: "root",
  storage: storageSession,
};

const rootReducer = combineReducers({
  counter: counterReducer,
  user: userReducer,
  auth: authReducer,
  tab: tabReducer,
  property: propertyReducer,
  PartyDetail: PartyDetailReducer,
  stepper: stepperReducer,
  originalDeed: originalDeedReducer,
  propertyInput: propertyInputReducer,
  propertyEvaluationInput: propertyEvaluationInputReducer,
  Aadhaar: AadhaarDetailsReducer,
  ResidentialModal: ResidentialModalReducer,
  CommercialModal: CommercialModalReducer,
  translate: translateReducer,
  OnlineAppointment: onlineAppointmentReducer,
  Procedure: ProcedureReducer,
  Modify: ModifySliceRducer,
  eSign: eSignDetailsReducer,
  MobileEmailOtp: MobileEmailModalReducer,
  reviewApproval: reviewApprovalReducer,
  uploadDoc: uploadDocumentReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
